import styled, { keyframes } from 'styled-components';
import { Icon } from '@web-chat-core/ui-kit';

export const MicrophoneOffIcon = styled(Icon)`
    --icon-color: ${(props) => props.theme.root.colors.basicColors.black['95%']};
`;

export const MicWithWave = styled.span`
    position: relative;
    display: inline-flex;
    line-height: 0;
`;

export const WaveOverlay = styled.div`
    position: absolute;
    inset: 0;
    pointer-events: none;
    --volume: 0;

    svg {
        overflow: visible;
        display: block;
    }
`;

/* Геометрия волны. Должна совпадать с числами в d-атрибуте WavePath
   (см. MicrophoneWaveOverlay): базовая линия — y=WAVE_BASELINE_Y, гребни
   поднимаются на WAVE_AMPLITUDE_PX выше неё. */
const VIEWBOX_HEIGHT_PX = 24;
const WAVE_BASELINE_Y = 4;
const WAVE_AMPLITUDE_PX = WAVE_BASELINE_Y; // гребень доходит до y=0
/* Сдвиг при volume=0: уводим базовую линию на полную высоту viewBox, плюс
   запас в полволны — чтобы гребни тоже ушли ниже нижней границы маски и
   при тишине от заливки не было видно ни пикселя. */
const HIDE_OFFSET_PX = VIEWBOX_HEIGHT_PX + WAVE_AMPLITUDE_PX / 2;

/* Группа волн целиком сдвигается по Y: при volume=0 — ниже viewBox'а (скрыта
   маской микрофона), при volume=1 — на уровне y=0. */
export const WaveGroup = styled.g`
    transform: translateY(calc((1 - var(--volume)) * ${HIDE_OFFSET_PX}px));
    transition: transform 120ms linear;
`;

const waveFlow = keyframes`
    from { transform: translateX(0); }
    to   { transform: translateX(-12px); }
`;

const waveFlowSlow = keyframes`
    from { transform: translateX(0); }
    to   { transform: translateX(-12px); }
`;

export const WavePath = styled.path`
    fill: ${(props) => props.theme.root.colors.accent.textOrIcon};
    opacity: 0.85;
    animation: ${waveFlow} 1.6s linear infinite;

    &[data-back] {
        opacity: 0.45;
        animation: ${waveFlowSlow} 2.6s linear infinite reverse;
    }
`;
